<template>
  <div>
    <ContentPage headerText="Discover Pilates Haven">
      <p>
        <strong>We offer the following services:</strong>
      </p>
      <ul class="list">
        <li>Reformer Pilates</li>
        <li>Mat Work</li>
        <li>Clinical Pilates</li>
        <li>Roller Class</li>
       
        
      </ul>
      <p>
        Please
        <router-link to="/contact-us/" class="underline"
          >Contact Us</router-link
        >
        for any enquires
      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="sections">
          <div
            v-for="service in services"
            :key="service.name"
            class="section"
          >
            <div>
              <h2>{{ service.name }}</h2>

              <p>{{ service.description }}</p>
            </div>

            <div class="image-card">
              <img
                class="image-card-img"
                :src="service.imgSrc"
                :alt="service.imgAltText"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/lib/services'
import ContentPage from '../partials/ContentPage.vue'

export default {
  name: 'areas-we-cover',
  components: {
    ContentPage
  },
  data () {
    return {
      services
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";

.content {
  padding-top: 64px;
  padding-bottom: 64px;
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 5rem;
}

.section {
  $gutter: 2rem;

  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: space-between;
  gap: $gutter;

  h2 {
    font-size: 2rem;
    margin-bottom: $gutter;
  }

  img {
    height: auto;
  }

  @media (min-width: $md-breakpoint) {
    gap: 4rem;
    flex-direction: row;

    > * {
      flex: 1;
    }

    &:nth-child(2n) {
      div:first-of-type {
        order: 2;
      }

      .image-card {
        order: 1;
      }
    }
  }
}

.list {
  display: flex;
  flex-wrap: wrap;

  margin-bottom: 30px;
  column-gap: 20px;

  li {
    width: 100%;

    @media (min-width: $xs-breakpoint) {
      width: 50%;
    }

    @media (min-width: $sm-md-breakpoint) {
      width: 33.33%;
    }

    @media (min-width: $md-breakpoint) {
      width: calc(33.33% - 20px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Services.vue